<template>
  <picture v-if="media || fallback">
    <template v-if="media">
      <source
        v-for="imageSource in media.sources"
        :key="imageSource.src"
        :media="imageSource.media"
        :width="imageSource.width"
        :height="imageSource.height"
        :srcset="imageSource.src"
      />
      <img
        v-if="media.img"
        :width="media.img.width"
        :height="media.img.height"
        :src="media.img.src"
        :alt="resolvedAlt || title"
        :loading="lazy ? 'lazy' : 'auto'"
        class="block w-full h-full object-cover"
        :class="imgClass"
      />
    </template>
    <img v-else src="/images/nixel.gif" class="block w-full h-full object-cover" />
  </picture>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getMediaImage } from '~/composables/media'

interface Props {
  image?: object
  alt?: string
  imgClass?: string
  lazy?: boolean
  fallback?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  image: undefined,
  alt: undefined,
  imgClass: '',
  lazy: true,
  fallback: false,
})

const media = computed(() => getMediaImage(props.image))
const resolvedAlt = computed(() => props.alt || props.image?.alt || props.image?.title)

const title = props.image?.title
</script>
